<script>
  import Header from "lib/components/Header.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import ButtonNew from "lib/components/ButtonNew.svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import {
    DataTable,
    Pagination,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
  } from "carbon-components-svelte";
  import ActionButtons from "../components/ActionButtons.svelte";
  import FormTimeDetails from "../components/FormTimeDetails.svelte";
  import FormSubActivity from "../components/FormSubActivity.svelte";
  import SubActivityDataTable from "../components/SubActivityDataTable.svelte";

  export let handleClose = () => {};
  /// temporary data left table

  let headersLeft = [
    { key: "clientName", value: "Mandant" },
    { key: "clientProcess", value: "Vorgang" },
    { key: "clientExpense", value: "Aufwand" },
    { key: "clientStart", value: "Beginn" },
    { key: "clientEnd", value: "Ende" },
    { key: "clientDate", value: "Datum" },
  ];

  let rowsLeft = [
    {
      id: 1,
      clientName: "Beispiel KG",
      clientProcess: "JA 2022",
      clientExpense: "1h 32min",
      clientStart: "08:00",
      clientEnd: "09:32",
      clientDate: "01.02.2024",
    },
    {
      id: 2,
      clientName: "Muster AG",
      clientProcess: "USt 05/24",
      clientExpense: "2h 25min",
      clientStart: "09:33",
      clientEnd: "11:55",
      clientDate: "01.02.2024",
    },
    {
      id: 3,
      clientName: "Ace GmbH",
      clientProcess: "KSt 2023",
      clientExpense: "1h 35min",
      clientStart: "12:35",
      clientEnd: "14:10",
      clientDate: "01.02.2024",
    },
  ];

  /// temporary data right table

  let headersRight = [
    { key: "activity", value: "Aktivität" },
    { key: "activityExpense", value: "Aufwand" },
    { key: "activityStart", value: "Beginn" },
    { key: "activityEnd", value: "Ende" },
    { key: "activityDate", value: "Datum" },
    // { key: "activityTasks", value: "Tasks" },
    { key: "activityActions", value: "Actions" },
  ];

  let rowsRight = [
    {
      id: 1,
      activity: "DATEV: Mandatenubersicht",
      activityExpense: "15 min",
      activityStart: "9:33",
      activityEnd: "09:48",
      activityDate: "01.02.2024",
      clientProcessId: 1,
    },
    {
      id: 2,
      activity: "DATEV: Stammdaten",
      activityExpense: "46 min",
      activityStart: "9:49",
      activityEnd: "10:35",
      activityDate: "01.02.2024",
      clientProcessId: 1,
    },
    {
      id: 3,
      activity: "DATEV: Sachkonten",
      activityExpense: "1h 19 min",
      activityStart: "10:36",
      activityEnd: "11:55",
      activityDate: "01.02.2024",
      clientProcessId: 1,
    },
    {
      id: 4,
      activity: "DATEV: Stammdaten 2",
      activityExpense: "46 min",
      activityStart: "9:49",
      activityEnd: "10:35",
      activityDate: "01.02.2024",
      clientProcessId: 2,
    },
    {
      id: 5,
      activity: "DATEV: Sachkonten 2",
      activityExpense: "1h 19 min",
      activityStart: "10:36",
      activityEnd: "11:55",
      activityDate: "01.02.2024",
      clientProcessId: 2,
    },
    {
      id: 6,
      activity: "DATEV: Stammdaten 3",
      activityExpense: "46 min",
      activityStart: "9:49",
      activityEnd: "10:35",
      activityDate: "01.02.2024",
      clientProcessId: 3,
    },
    {
      id: 7,
      activity: "DATEV: Sachkonten 3",
      activityExpense: "1h 19 min",
      activityStart: "10:36",
      activityEnd: "11:55",
      activityDate: "01.02.2024",
      clientProcessId: 3,
    },
  ];

  let rowsExpandable = [
    {
      id: 1,
      subActivityName: "Outlook: AW Rechnung",
      subActivityExpense: "45 min",
      subActivityStart: "10:05",
      subActivityEnd: "10:50",
      subActivityDate: "01.02.2024",
      activityId: 1,
    },
    {
      id: 2,
      subActivityName: "DATEV: Zeiten erfassen",
      subActivityExpense: "1h 10 min",
      subActivityStart: "10:50",
      subActivityEnd: "12:00",
      subActivityDate: "01.02.2024",
      activityId: 1,
    },
    {
      id: 3,
      subActivityName: "Excel: Rechnungen_0524",
      subActivityExpense: "45 min",
      subActivityStart: "12:00",
      subActivityEnd: "12:45",
      subActivityDate: "01.02.2024",
      activityId: 1,
    },
    {
      id: 4,
      subActivityName: "Fehlende Aktivität",
      subActivityExpense: "25 min",
      subActivityStart: "12:45",
      subActivityEnd: "13:10",
      subActivityDate: "01.02.2024",
      activityId: 1,
    },
    {
      id: 5,
      subActivityName: "Excel: Rechnungen_0524 2",
      subActivityExpense: "45 min",
      subActivityStart: "12:00",
      subActivityEnd: "12:45",
      subActivityDate: "01.02.2024",
      activityId: 2,
    },
    {
      id: 6,
      subActivityName: "Fehlende Aktivität 2",
      subActivityExpense: "25 min",
      subActivityStart: "12:45",
      subActivityEnd: "13:10",
      subActivityDate: "01.02.2024",
      activityId: 2,
    },
    {
      id: 7,
      subActivityName: "Outlook: AW Rechnung",
      subActivityExpense: "45 min",
      subActivityStart: "10:05",
      subActivityEnd: "10:50",
      subActivityDate: "01.02.2024",
      activityId: 4,
    },
    {
      id: 8,
      subActivityName: "DATEV: Zeiten erfassen",
      subActivityExpense: "1h 10 min",
      subActivityStart: "10:50",
      subActivityEnd: "12:00",
      subActivityDate: "01.02.2024",
      activityId: 4,
    },
  ];

  let pageSizeRight = 15;
  let pageRight = 1;
  let pageSizeLeft = 15;
  let pageLeft = 1;
  let filteredRowIdsLeft = [];
  let filteredRowIdsRight = [];
  let selectedRow;
  let activitiesByRow = [];
  let selectedActivity;
  let subActivitiesByRow = [];
  let expandedRowIds = [];
  let deletedActivityRows = [];
  let deletedSubActivityRows = [];
  let openEditActivityModal = false;
  let rowToEdit = {};
  let openSubActivityModal = false;
  let subActivityToEdit = {};
  let subActivitySelected;
  let valueToEdit = { row: -1, key: "" };
  let datePicker = "";
  const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

  $: {
    if (selectedRow) {
      activitiesByRow = rowsRight.filter(
        (row) => row.clientProcessId === selectedRow
      );
    }
  }

  $: {
    if (selectedActivity) {
      subActivitiesByRow = rowsExpandable.filter(
        (row) => row.activityId === selectedActivity
      );
    }
  }

  function handleDelete(id, type) {
    if (type === "activity") {
      console.log("Delete activity", id);
      if (isDeleted(id, "activity")) {
        deletedActivityRows = deletedActivityRows.filter((row) => row !== id);
      } else {
        deletedActivityRows = [...deletedActivityRows, id];
        const subActivitiesToDelete = rowsExpandable
          .filter((row) => row.activityId === id)
          .map((row) => row.id);
        deletedSubActivityRows = [
          ...deletedSubActivityRows,
          ...subActivitiesToDelete,
        ];
        expandedRowIds = [];
      }
      activitiesByRow = [...activitiesByRow];
    } else if (type === "subActivity") {
      console.log("Delete subActivity", id);
      if (isDeleted(id, "subActivity")) {
        deletedSubActivityRows = deletedSubActivityRows.filter(
          (row) => row !== id
        );
      } else {
        deletedSubActivityRows = [...deletedSubActivityRows, id];
      }
      subActivitiesByRow = [...subActivitiesByRow];
    }
  }

  function handleEdit(id, type) {
    console.log("Edit", id);
    if (type === "activity") {
      selectedActivity = id;
      rowToEdit = rowsRight.find((row) => row.id === id);
      openEditActivityModal = true;
    } else if (type === "subActivity") {
      console.log("Edit subActivity", id);
      subActivitySelected = id;
      subActivityToEdit = rowsExpandable.find((row) => row.id === id);
      openSubActivityModal = true;
    }
  }

  function isDeleted(id, type) {
    if (type === "activity") {
      return deletedActivityRows.includes(id);
    } else if (type === "subActivity") {
      return deletedSubActivityRows.includes(id);
    }
  }

  function handleCloseActivityModal() {
    openEditActivityModal = false;
  }

  function handleAdd(e, id, key) {
    const index = rowsExpandable.findIndex((row) => row.id === id);
    console.log("handleAdd index:", index, "key", key, "value", e.target.value);
    rowsExpandable[index][key] = e.target.value;
    console.log("handleAdd rowsExpandable", rowsExpandable);
    rowsExpandable = [...rowsExpandable];
    valueToEdit = { row: -1, key: "" };
  }

  function handleDateChange(event, id) {
    const index = rowsExpandable.findIndex((row) => row.id === id);
    rowsExpandable[index].subActivityDate = handleDateFormat(
      event.target.value
    );
    rowsExpandable = [...rowsExpandable];
    datePicker = false;
  }

  function handleDateFormat(date) {
    const dateArray = date.split("-");
    const year = dateArray[0];
    const month = dateArray[1];
    const day = dateArray[2];
    return `${day}.${month}.${year}`;
  }

  function handleUpdateTime(event, id, key) {
    const index = rowsExpandable.findIndex((row) => row.id === id);
    rowsExpandable[index][key] = event.target.value;
    rowsExpandable[index].subActivityExpense = calculateExpense(
      rowsExpandable[index].subActivityStart,
      rowsExpandable[index].subActivityEnd
    );
    rowsExpandable = [...rowsExpandable];
  }

  function calculateExpense(start, end) {
    if (!start || !end) {
      return "-";
    }
    if (isValidTime(start, end)) {
      const [startHour, startMinute] = start.split(":").map(Number);
      const [endHour, endMinute] = end.split(":").map(Number);

      let totalMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);
      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}min`;
    } else {
      return "-";
    }
  }

  function isValidTime(start, end) {
    return start.match(timePattern) && end.match(timePattern);
  }
</script>

<Header section="Time Tracker" breadcrumb="Details">
  <ButtonNew setting={true} secondary={true} text="Assistant" />
  <ButtonNew setting={true} secondary={true} text="Send to DATEV" />
  <ButtonNew
    setting={true}
    secondary={true}
    text="Back"
    on:click={handleClose}
  />
</Header>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="table_wrapper">
      <!-- Left Table -->
      <div>
        <DataTable
          headers={headersLeft}
          rows={rowsLeft}
          sortable
          class="custom-table"
          page={pageLeft}
          pageSize={pageSizeLeft}
          on:click:row={(e) => {
            selectedRow = e.detail.id;
          }}
        >
          <Toolbar style="margin-bottom: 10px;">
            <ToolbarContent>
              <ToolbarSearch
                bind:filteredRowIds={filteredRowIdsLeft}
                shouldFilterRows
                persistent
                placeholder="Suche nach..."
              />
            </ToolbarContent>
          </Toolbar>
        </DataTable>
        <Pagination
          bind:pageSize={pageSizeLeft}
          bind:page={pageLeft}
          totalItems={filteredRowIdsLeft.length}
          pageSizes={[15, 30, 50]}
          itemsPerPageText="zeilen pro Seite"
          itemRangeText={(min, max, total) =>
            `${min} - ${max} of ${total} Positionen`}
          pageRangeText={(current, total) => ` of ${total} Seiten`}
        />
      </div>
      <!-- Right Table -->
      <div>
        <DataTable
          headers={headersRight}
          rows={activitiesByRow}
          sortable
          class="custom-table"
          page={pageRight}
          pageSize={pageSizeRight}
          expandable
          bind:expandedRowIds
          on:click:row--expand={(e) => {
            if (!e.detail.expanded) expandedRowIds = [];
            else expandedRowIds = [e.detail.row.id];
            selectedActivity = e.detail.row.id;
          }}
        >
          <Toolbar style="margin-bottom: 10px;">
            <ToolbarContent>
              <ToolbarSearch
                bind:filteredRowIds={filteredRowIdsRight}
                shouldFilterRows
                persistent
                placeholder="Suche nach..."
              />
            </ToolbarContent>
          </Toolbar>

          <svelte:fragment slot="cell" let:row let:cell>
            <div class="row_class">
              {#if cell.key === "activityActions"}
                <ActionButtons
                  small
                  handleDelete={() => handleDelete(row.id, "activity")}
                  handleEdit={() => handleEdit(row.id, "activity")}
                  handleRestart={() => handleDelete(row.id, "activity")}
                  restart={isDeleted(row.id, "activity")}
                />
              {:else}
                <span class:deleted-cell={isDeleted(row.id, "activity")}>
                  {cell.value}
                </span>
              {/if}
            </div>
          </svelte:fragment>
          <div class="menu_wrapper interations" slot="expanded-row">
            {#key subActivitiesByRow}
              <SubActivityDataTable
                {subActivitiesByRow}
                headers={headersRight}
                {deletedSubActivityRows}
                {handleEdit}
                {handleDelete}
                {handleDateChange}
                {handleUpdateTime}
                {deletedActivityRows}
                {handleAdd}
              />
            {/key}
          </div>
        </DataTable>
        <Pagination
          bind:pageSize={pageSizeRight}
          bind:page={pageRight}
          totalItems={filteredRowIdsRight.length}
          pageSizes={[15, 30, 50]}
          itemsPerPageText="zeilen pro Seite"
          itemRangeText={(min, max, total) =>
            `${min} - ${max} of ${total} Positionen`}
          pageRangeText={(current, total) => ` of ${total} Seiten`}
        />
      </div>
    </div>
  </div>
</SectionWrapper>

<Modal
  modalHeading="Position ändern"
  autowidth={true}
  secondaryButtonText="Speichern"
  primaryButtonText="Abbrechen"
  open={openEditActivityModal}
  on:close={handleCloseActivityModal}
  primaryButtonAction={() => {
    rowsRight = rowsRight.filter((row) => row.id !== selectedActivity);
    rowsRight = [...rowsRight, rowToEdit];
    openEditActivityModal = false;
  }}
  actions={true}
>
  <FormTimeDetails
    bind:rowToEdit
    bind:subActivitiesByRow
    bind:rowsExpandable
    headers={headersRight}
    bind:deletedSubActivityRows
    {selectedActivity}
    {handleEdit}
    {handleDateChange}
    {handleUpdateTime}
    {deletedActivityRows}
    {handleAdd}
  />
</Modal>

<Modal
  modalHeading="Position ändern"
  autowidth={true}
  secondaryButtonText="Speichern"
  primaryButtonText="Abbrechen"
  open={openSubActivityModal}
  on:close={() => (openSubActivityModal = false)}
  primaryButtonAction={() => {
    rowsExpandable = rowsExpandable.filter(
      (row) => row.id !== subActivitySelected
    );
    rowsExpandable = [...rowsExpandable, subActivityToEdit];
    openSubActivityModal = false;
  }}
  actions={true}
>
  <FormSubActivity {subActivityToEdit} />
</Modal>

<style>
  .main {
    width: 100%;
  }

  .table_wrapper {
    display: grid;
    grid-template-columns: 1fr 0.6fr;
    gap: 1rem;
  }

  .deleted-cell {
    text-decoration: line-through;
    opacity: 0.5;
  }
</style>
